import * as FromDataEnrichment from 'reducers/dataEnrichment/selectors';

export const SLICE = 'dataEnrichment';

export const getFilters = userId => state =>
  FromDataEnrichment.getFilters(userId, state[SLICE]);
export const getDateOption = userId => state =>
  FromDataEnrichment.getDateOption(userId, state[SLICE]);
export const getSignalRDataEnrichmentId = state =>
  FromDataEnrichment.getSignalRDataEnrichmentId(state[SLICE]);
